module.exports = __webpack_public_path__ + "img/Banner_hochkannt.61ee13ad.webp";